module.exports = __webpack_public_path__ + "static/cooking-675c407729482c8309015307163f0c48.gif";